import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer } from "ui"
import { getBreadCrumbs, transformProperties } from "utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const components = {
  heroBanner: () => import("../Common/Hero"),
  tabsContent: () => import("../Common/TabsContent"),
}

export default function GeneralPage({ data, locale }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      {blocks?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => {
          return (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
              locale={locale}
              props={{ breadCrumbs }}
            />
          )
        },
      )}
    </>
  )
}
